<template>
    <div>

        <div class="vx-row">
            <div class="vx-col w-full">
                <vx-card titleIcon="EyeIcon" ref="filterCard" title="Summary" class="mb-8 user-list-filters"
                    :collapse-action="false">
                    <div class="vx-row">
                        <div class="vx-col w-1/4" style="line-height: 25px;">
                            <vs-list>
                                <vs-list-header title="NEXT CONTACT"></vs-list-header>
                                Contact Event ID : {{ contact_summary.next_contact.code }} <br>
                                Followup: {{ contact_summary.next_contact.follow_up_timestamp_human }} <br>
                                Timeline: {{ contact_summary.next_contact.created_at_human }}
                            </vs-list>
                        </div>
                        <div class="vx-col w-1/4" style="line-height: 25px;">
                            <vs-list>
                                <vs-list-header title="LAST CONTACT MADE"></vs-list-header>
                                Contact Event ID : {{ contact_summary.last_contact.code }} <br>
                                Created By: {{ contact_summary.last_contact.created_by.name }} <br>
                                Timeline: {{ contact_summary.last_contact.created_at_human }}
                            </vs-list>
                        </div>
                        <div class="vx-col w-1/4" style="line-height: 25px;">
                            <vs-list>
                                <vs-list-header title="USERS IN NIMBLE"></vs-list-header>
                                {{ contact_summary.active_users }}
                            </vs-list>
                            <vs-list>
                                <vs-list-header title="SAMPLE ORDER COUNT"></vs-list-header>
                                {{ contact_summary.sample_orders_count }}
                            </vs-list>
                        </div>
                        <div class="vx-col w-1/4" style="line-height: 25px;">
                            <vs-list>
                                <vs-list-header title="ORDER COUNT"></vs-list-header>
                                {{ contact_summary.orders_count }}
                            </vs-list>
                            <vs-list>
                                <vs-list-header title="PROJECT BRIEF COUNT"></vs-list-header>
                                {{ contact_summary.project_briefs_count }}
                            </vs-list>
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>

        <div class="vx-row mb-4">
            <div class="vx-col w-full">
                <CustomerCrmSnapshotSummaryReport :account_currency="account_currency" />
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col w-full">
                <CustomerCrmSnapshotList v-on:refreshSummary="fetchContactSummary" />
            </div>
        </div>
    </div>
</template>
<script>

import { RepositoryFactory } from '@/repository/RepositoryFactory';
const CrmRepository = RepositoryFactory.get('crm');
import CustomerCrmSnapshotList from './CustomerCrmSnapshotList.vue';
import CustomerCrmSnapshotSummaryReport from './CustomerCrmSnapshotSummaryReport.vue'

export default {
    name: 'CustomerCrmSnapshotHome',
    props: {
        account_currency: {
            default: 'GBP'
        }
    },
    data() {
        return {
            contact_types: [
                {
                    tab_name: 'EMAIL',
                    type: 'email',
                },
                {
                    tab_name: 'EVENT',
                    type: 'event',
                },
                {
                    tab_name: 'CALL',
                    type: 'call',
                },
                {
                    tab_name: 'F2F MEETING',
                    type: 'f2f-meeting',
                },
                {
                    tab_name: 'OTHER',
                    type: 'other',
                }
            ],
            contact_summary: {
                next_contact: {
                    code: '',
                    created_at_human: '',
                    follow_up_timestamp_human: ''
                },
                last_contact: {
                    code: '',
                    created_at_human: '',
                    created_by: {
                        name: ''
                    }
                },
                orders_count: 0,
                project_briefs_count: 0,
                sample_orders_count: 0,
                active_users: 0
            }
        }
    },
    components: {
        CustomerCrmSnapshotList,
        CustomerCrmSnapshotSummaryReport,
    },
    async mounted() {
        await this.fetchContactSummary()
    },
    methods: {
        async fetchContactSummary() {
            try {
                const { data } = await CrmRepository.viewCustomerCrmSnapShotSummary(this.$route.params.id)
                this.contact_summary = data.data
            } catch (error) {

            }
        }
    },
}
</script>
<style lang="">
    
</style>